import {
	ProfileImageComponent,
	UserLevelComponent,
	DryRunOverrideLabel,
	LoginButtons,
	UserInfo,
	GenericBalance
} from "./lib";
import { WsDialogs } from "interfaces";
import coinIcon from "assets/coin.png";
import { Box, Grid } from "@mui/material";
import { CrownIcon, CrownIconV2 } from "utils/svgIcons";
import { useEnvContext, useGoogleAnalyticsContext } from "contexts";
import { User, UserProfileContainer } from "./styled";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import { FeaturesFlags } from "helpers";

const UserProfile = (): JSX.Element => {
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { userTracker, authToken } = useWebStoreContext();
	const { isFeatureFlagEnabled } = useEnvContext();
	const { openDialog } = useDialogModalRedux();
	const inventory = userTracker?.inventory;

	const handleClickLoyaltyPoints = () => {
		openDialog(WsDialogs.LOYALTY_FAQ);
		reportEvent("loyalty_points_click", { source: "right_menu" });
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "loyalty_points_click",
			event_type: "top navbar",
			action: "loyalty_points_click",
			source: "navbar"
		});
		reportEvent("dialog_shown", { source: "loyalty_faq_dialog" });
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "dialog_shown",
			event_type: "loyalty_faq_dialog",
			action: "dialog_shown",
			source: "loyalty_faq_dialog"
		});
	};

	return (
		<Box
			sx={{
				width: "100%"
			}}
		>
			{userTracker && authToken ? (
				<UserProfileContainer>
					<User>
						<ProfileImageComponent />
						<UserInfo />
					</User>
					<UserLevelComponent />
					<Grid container spacing={0.6} alignItems="center">
						{/* </Grid><Grid item xs={11} sm={6} md={11}> */}
						<Grid item xs={12} sm={12} md={12}>
							<GenericBalance
								text="Coins"
								icon={<img src={coinIcon} alt="" />}
								points={inventory?.coins ?? 0}
							/>
						</Grid>
						{/* </Grid><Grid item xs={11} sm={6} md={11}> */}
						<Grid item xs={12} sm={12} md={12}>
							<GenericBalance
								text="Loyalty Points"
								icon={
									isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
										<CrownIconV2 width={18} />
									) : (
										<CrownIcon fill="#113B62" />
									)
								}
								points={userTracker.loyaltyPoints}
								onClick={handleClickLoyaltyPoints}
							/>
						</Grid>
					</Grid>
					<DryRunOverrideLabel />
				</UserProfileContainer>
			) : (
				<LoginButtons />
			)}
		</Box>
	);
};

export default UserProfile;
